import { render, staticRenderFns } from "./areaBtns.vue?vue&type=template&id=74a6b654&scoped=true&"
import script from "./areaBtns.vue?vue&type=script&lang=js&"
export * from "./areaBtns.vue?vue&type=script&lang=js&"
import style0 from "./areaBtns.vue?vue&type=style&index=0&id=74a6b654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a6b654",
  null
  
)

export default component.exports